import React, { useCallback } from 'react';
import { Box, DialogContent, DialogTitle } from '@mui/material';
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useVisaTypeRequest } from '../../hooks/visaTypeRequest';

interface FormData {
  name: string;
}

interface CreateVisaProps {
  setDialogOpen: (open: boolean) => void;
}

const validationSchema = yup.object().shape({
  name: yup.string().required("Name is required")
});

const CreateVisa: React.FC<CreateVisaProps> = ({ setDialogOpen }) => {
  const visaRequest = useVisaTypeRequest();
  const { control, handleSubmit, formState: { errors } } = useForm<FormData>({
    resolver: yupResolver(validationSchema)
  });

  const onSubmit = useCallback(async (data: FormData) => {
    const dispatchData = await visaRequest({ method: 'POST', data: data, slug: null, query: null });
    if (dispatchData.meta.requestStatus === 'fulfilled') {
      setDialogOpen(false);
      await visaRequest({ method: 'get', data: null, slug: null, query: null });
    }
  }, [visaRequest, setDialogOpen]);

  return (
    <DialogContent>
      <DialogTitle sx={{ p: 0 }}>Add New Visa Type</DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)} autoComplete='off'>
        <Controller
          name="name"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              autoFocus
              sx={{ width: 300 }}
              {...field}
              label="Name"
              variant="standard"
              error={!!errors.name}
              helperText={errors.name ? errors.name.message : ''}
              fullWidth
              margin="normal"
            />
          )}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mt: 2 }}>
          <Button sx={{ mr: 2 }} onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button type="submit" variant="contained" color="primary">
            Save
          </Button>
        </Box>
      </form>
    </DialogContent>
  );
};

export default CreateVisa;
